export enum BaryInputCountryField {
  NAME = 'NAME',
  KEY = 'KEY',
}
